var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F4F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.9375V21.75H11.0625L19.3575 13.455L16.545 10.6425L8.25 18.9375ZM21.5325 11.28C21.825 10.9875 21.825 10.515 21.5325 10.2225L19.7775 8.46749C19.485 8.17499 19.0125 8.17499 18.72 8.46749L17.3475 9.83999L20.16 12.6525L21.5325 11.28Z",
    fill: "#0098CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlined);
export default __webpack_public_path__ + "static/media/edit-outlined.62787ec7a325e7e841345acbfdec945f.svg";
export { ForwardRef as ReactComponent };